// extracted by mini-css-extract-plugin
export default {"title":"PortholeLink_title__JwRgH","wrapper":"PortholeLink_wrapper__guNp1","porthole":"PortholeLink_porthole__xJTEf"};